import { toJpeg } from "html-to-image";
import { useEffect, useState } from "react";
import useAxiosPrivate from "../../api/useAxiosPrivate";
import { notify } from "../toast";
import { useParams } from "react-router-dom";
import '../../styles/dashboard.css';
import Modal from 'react-modal';
import imageCompression from "browser-image-compression";
import { QRCodeCanvas } from "qrcode.react";

const EmployeeHolderCard = () => {

    const { id } = useParams();
    const axiosPrivate = useAxiosPrivate();

    const [name, setName] = useState('');
    const [holderId, setHolderId] = useState('');
    const [gender, setGender] = useState('');
    const [mobile, setMobile] = useState('');
    const [village, setVillage] = useState('');
    const [mandal, setMandal] = useState('');
    const [district, setDistrict] = useState('');
    const [pincode, setPincode] = useState('');
    const [photo, setPhoto] = useState('');

    const [validity, setValidity] = useState('');
    const [loading, setLoading] = useState(false);

    const [openPhotoUpload, setOpenPhotoUpload] = useState(false);

    const fetchHolderDetails = async () => {
        try {

            const response = await axiosPrivate.get(`/employee/getHolderCard/${id}`);

            const data = response?.data
            setName(data?.name);
            setHolderId(data?.holderId);
            setGender(data?.gender);
            setMobile(data?.mobile);
            setVillage(data?.village);
            setMandal(data?.mandal);
            setDistrict(data?.district);
            setPincode(data?.pincode);
            setPhoto(data?.photo?.data && `data:image/jpeg;base64,${bufferToBase64(data?.photo?.data)}`);

            const d = new Date(data?.createdAt);
            d.setFullYear(d.getFullYear() + 5);
            setValidity(String(d.getDate()).padStart(2, '0') + '/' +
                String(d.getMonth() + 1).padStart(2, '0') + '/' +
                d.getFullYear())

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchHolderDetails();
        // eslint-disable-next-line
    }, []);

    const download = async () => {
        const node = document.getElementById("health-card");
        try {
            // const dataUrl = await toJpeg(cardRef.current, {
            const dataUrl = await toJpeg(node, {
                quality: 0.95,
                pixelRatio: 2,
                cacheBust: true,
            });
            const link = document.createElement("a");
            link.download = `${name}-health-card.jpg`;
            link.href = dataUrl;
            link.click();
        } catch (err) {
            console.log(err)
        }
    };

    const bufferToBase64 = (bufferArray) => {
        const chunkSize = 100000;
        let base64String = '';

        for (let i = 0; i < bufferArray.length; i += chunkSize) {
            const chunk = bufferArray.slice(i, i + chunkSize);
            base64String += String.fromCharCode.apply(null, chunk);
        }

        return btoa(base64String);
    }

    const handlePhoto = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);

            const photo = document.getElementById("photo");
            const fd = new FormData();

            // @ts-ignore
            if (!photo?.files[0]) {
                notify('info', 'Please select image before uploading')
                return
            }

            // @ts-ignore
            const compressedImage = await compressImage(photo?.files[0])
            fd.append('photo', compressedImage);

            const response = await axiosPrivate.post(`/employee/uploadHolderPhoto/${id}`, fd,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

            const success = response?.data?.success;
            if (success) {
                notify('success', success);
                fetchHolderDetails();
            }

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setLoading(false);
            setOpenPhotoUpload(false);
        }
    }

    const compressImage = async (file) => {
        const options = {
            maxSizeMB: 0.048,
            maxWidthOrHeight: 600,
            useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        return compressedFile;
    };

    return (
        <>
            <div
                style={{
                    margin: 20,
                    transform: "scale(0.35)",
                    transformOrigin: "top left",
                    width: "1031px",
                    height: "653px",
                }}
            >
                <div
                    id="health-card"
                    style={{
                        width: "1031px",
                        height: "653px",
                        backgroundImage: `url('/ID_cards/ayush_health.jpg')`,
                        backgroundSize: "100% 100%",
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            paddingTop: 250,
                            marginLeft: 40,
                            marginRight: 40,
                        }}>

                        {photo ?

                            <img
                                src={photo}
                                alt="profile"
                                style={{
                                    width: 200,
                                    height: 280,
                                    objectFit: "contain",
                                }}
                            />
                            :
                            <div style={{
                                width: 200,
                                height: 280,
                                objectFit: "contain",
                            }}></div>
                        }

                        <div
                            style={{
                                color: '#2b4265',
                                fontWeight: '600',
                                fontSize: '2.1rem',
                                marginLeft: 40,
                                marginRight: 40,
                                wordBreak: 'break-word'
                            }}>

                            <div>
                                <div
                                    style={{
                                        color: '#373340',
                                        fontSize: '1.3rem'
                                    }}>Name</div>
                                {name}
                            </div>

                            <div>
                                <div
                                    style={{
                                        color: '#373340',
                                        fontSize: '1.3rem'
                                    }}>Ayush Card No.</div>
                                {holderId}
                            </div>

                            <span>
                                <div
                                    style={{
                                        color: '#373340',
                                        fontSize: '1.3rem'
                                    }}>Address</div>
                                {village}, {mandal}, {district}, {pincode}
                            </span>

                        </div>

                        <div
                            style={{
                                marginLeft: 'auto',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                            <span
                                style={{
                                    color: '#373340',
                                    fontSize: '1.3rem'
                                }}>Card validity : {validity}</span>
                            <br />
                            <QRCodeCanvas
                                value={id}
                                size={200}
                                bgColor="#ffffff"
                                fgColor="#000000"
                                level="H"
                            />
                        </div>

                    </div>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: 10,
                            marginLeft: 280,
                            marginRight: 280,
                            color: '#373340',
                            fontSize: '1.3rem',
                            fontWeight: '600',
                        }}>
                        <div>
                            <div>Gender</div>
                            {gender}
                        </div>

                        <div>
                            <div>Mobile</div>
                            {mobile}
                        </div>
                    </div>

                </div>

                <div
                    style={{
                        textAlign: 'center',
                        margin: '2rem',
                        transform: 'scale(2)'
                    }}>
                    <button className="add-btn" onClick={() => download()}>download</button>&nbsp;
                    <button className="add-btn" onClick={() => setOpenPhotoUpload(true)}>Change photo</button>
                </div>

            </div>

            <Modal
                isOpen={openPhotoUpload}
                onRequestClose={() => setOpenPhotoUpload(false)}
                style={{
                    overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
                }}
                className='formContainer'
            >
                <div className='formWrapper'>
                    <h2 className='formTitle'>Holder photo upload</h2>
                    <form onSubmit={handlePhoto}>

                        <div className="formGroup">
                            <input
                                className="formInput"
                                type="file"
                                id="photo"
                                name='photo'
                            />
                        </div>
                        <div className="formRow">
                            <button
                                className='close-btn'
                                style={{ width: '95%' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setOpenPhotoUpload(false);
                                }}>
                                <span>Close</span>
                            </button>
                            <button className="submitButton"> {loading ? <span className='spinner' /> : 'Upload'}</button>
                        </div>
                    </form>
                </div>

            </Modal >

        </>
    );
}

export default EmployeeHolderCard
